import React from "react";
import { connect, useSelector } from "react-redux";
import { Link } from "react-router-dom";

// ACTIONS
import { currentLang } from "../../../store/features/translation/selectors";
import { languages } from "../../../store/features/translation/Languages/";

// SELECTORS
import { switchLang } from "../../../store/features/translation/actions";
import { BannerContainer } from "./styled";

// IMGS
import bannerEn from "../../../assets/img/banner_en.jpg";
import bannerGr from "../../../assets/img/banner_gr.jpg";

function Footer({ switchLang }) {
	// SELECTORS
	const currentLanguage = useSelector(currentLang);

	// STATES
	const [lang] = React.useState(["EN", "GR", "FR"]);

	return (
		<footer id="home-footer-wrapper">
			<div className="footer-area footer-padding">
				<div className="">
					<div className="row d-flex justify-content-between">
						<div className="col-12">
							<Link to="/">
								<img src={require("../../../assets/svg/keeano-icon.svg")} />
							</Link>
						</div>
						<div className="col-lg-3 col-md-4 col-sm-8 mb-4">
							<div className="single-footer-caption mb-50">
								<div className="single-footer-caption mb-30">
									<div className="footer-logo">
										<Link to="/">
											<svg
												xmlns="http://www.w3.org/2000/svg"
												width="83"
												height="16"
												viewBox="0 0 93 20"
											>
												<title
													style={{
														backgroundColor: "transparent",
														border: "none",
													}}
												>
													keeano
												</title>
												<g fill="none" fillRule="evenodd">
													<g fill="#222C4B" fillRule="nonzero">
														<g>
															<path
																d="M70.392 4.62c-1.568-.032-3.059.683-4.015 1.926l-.077.1v-1.76h-2.473v14.78h2.57v-8.35c0-2.757 1.455-4.34 3.988-4.34 2.4 0 3.293 1.082 3.293 3.989v8.704h2.578v-8.704c0-2.067-.473-3.648-1.408-4.697-.974-1.093-2.47-1.647-4.456-1.647zM86.02 4.567c-4.276 0-6.933 2.956-6.933 7.714 0 4.758 2.657 7.713 6.932 7.713 4.276 0 6.936-2.955 6.936-7.713s-2.657-7.714-6.936-7.714zm0 13.019c-2.73 0-4.362-1.985-4.362-5.305 0-3.32 1.631-5.304 4.361-5.304 2.73 0 4.364 1.985 4.364 5.304 0 3.32-1.632 5.305-4.364 5.305zM7.393 11.495c.742-.563 1.421-1.202 2.028-1.907 1.15-1.364 2.08-2.898 2.756-4.55l.077-.178H9.482l-.035.074C8.32 7.247 6.827 8.968 5.01 10.049c-.727.44-1.52.76-2.35.945l-.052.01V0H0v19.658h2.608v-6.082h.038c.863-.122 1.698-.39 2.472-.79l.034-.016 4.886 6.893h3.16L7.36 11.519l.033-.024zM20.956 4.567c-2.193 0-4.03.742-5.31 2.147-1.258 1.374-1.922 3.321-1.922 5.622 0 2.259.658 4.169 1.901 5.526 1.28 1.394 3.123 2.138 5.33 2.138 3.032 0 5.406-1.496 6.526-4.106l-2.439-.849c-.086.176-.179.347-.235.458-.819 1.374-2.15 2.09-3.857 2.09-2.553 0-4.276-1.624-4.613-4.345v-.049h11.82v-.863c0-4.72-2.826-7.769-7.201-7.769zm-4.499 6.213l.013-.052c.48-2.348 2.159-3.751 4.486-3.751 2.29 0 3.952 1.403 4.456 3.751l.012.052h-8.967zM37.716 4.567c-2.195 0-4.031.742-5.313 2.147-1.256 1.374-1.919 3.321-1.919 5.622 0 2.259.657 4.169 1.9 5.526C33.664 19.256 35.506 20 37.716 20c3.022 0 5.394-1.489 6.517-4.088l-2.436-.844c-.085.176-.177.345-.227.44-.814 1.363-2.147 2.084-3.854 2.084-2.555 0-4.276-1.625-4.613-4.346v-.049h11.82v-.86c-.002-4.72-2.828-7.77-7.207-7.77zm-4.494 6.213l.01-.052c.485-2.348 2.163-3.751 4.484-3.751 2.29 0 3.95 1.403 4.457 3.751l.01.052h-8.961zM59.97 16.612v-6.456c0-1.799-.631-3.262-1.833-4.233-1.092-.887-2.63-1.356-4.443-1.356-2.947 0-4.974 1.927-5.813 3.578l-.061.119 2.22 1.041.058-.107c.232-.404.511-.78.83-1.12.743-.775 1.777-1.203 2.85-1.18 2.348 0 3.615 1.264 3.615 2.453v.18c-.062.816-2.256 1.187-4.086 1.356-1.895.18-3.391.672-4.445 1.463-1.14.86-1.72 1.968-1.72 3.294 0 2.65 1.914 4.3 4.996 4.3 2.525 0 4.275-.683 5.358-2.085l.049-.064.026.078c.378 1.159 1.423 1.797 2.94 1.797h.585v-2.415h-.61c-.477 0-.517-.49-.517-.643zm-2.57-4.244c0 1.782-.413 3.07-1.242 3.934-.829.864-2.052 1.278-3.747 1.278-1.585 0-2.693-.799-2.693-1.942 0-1.453 1.128-2.138 4.025-2.454 1.714-.18 2.89-.338 3.588-.85l.069-.051v.085z"
																transform="translate(-32.000000, -18.000000) translate(32.000000, 18.000000)"
															/>
														</g>
													</g>
												</g>
											</svg>
										</Link>
									</div>
									<div className="footer-tittle">
										<div className="footer-pera">
											<p className="info1">
												{languages[currentLanguage]["home_footer_moto_title"]}
												<br />
											</p>
											<div className="footer-languages">
												{lang.map((l, id) => (
													<a
														key={id}
														onClick={() => switchLang(l)}
														style={{
															cursor: "pointer",
															borderTop: `2px solid ${
																currentLanguage === l ? "" : "transparent"
															}`,
														}}
													>
														{l}
													</a>
												))}
											</div>
										</div>
									</div>
									<div className="footer-social">
										<a
											target="_blank"
											href="https://www.facebook.com/keeanoapp"
										>
											<i className="fab fa-facebook-f"></i>
										</a>
										<a
											target="_blank"
											href="https://www.instagram.com/keeanoapp"
										>
											<i className="fab fa-instagram"></i>
										</a>
										<a target="_blank" href="https://www.twitter.com/keeanoapp">
											<i className="fab fa-twitter"></i>
										</a>
									</div>
									<div className="d-none d-md-block footer-banner">
										<BannerContainer
											src={
												currentLanguage === "EN"
													? bannerEn
													: currentLanguage === "GR"
													? bannerGr
													: ""
											}
										/>
									</div>
								</div>
							</div>
						</div>

						<div className="col-lg-2 col-md-4 col-sm-5 mb-4">
							<div className="single-footer-caption mb-50">
								<div className="footer-tittle">
									<h4>
										{
											languages[currentLanguage][
												"home_footer_quicklinks_header"
											]
										}
									</h4>
									<ul>
										<li>
											<a target="_blank" href="https://blog.keeano.com/">
												{
													languages[currentLanguage][
														"home_footer_quicklinks_blog_button"
													]
												}
											</a>
										</li>
										<li>
											<a target="_blank" href="https://bit.ly/keeano_media_kit">
												{
													languages[currentLanguage][
														"home_footer_quicklinks_mediakit_button"
													]
												}
											</a>
										</li>
										<li>
											<a target="_blank" href="mailto:contact@keeano.com">
												{languages[currentLanguage]["place_details_contact"]}
											</a>
										</li>
										<li>
											<Link to="/virtual-guide/FAQ">Virtual Guide</Link>
										</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="col-lg-2 col-md-4 col-sm-7 mb-4">
							<div className="single-footer-caption mb-50">
								<div className="footer-tittle">
									<h4>
										{
											languages[currentLanguage][
												"home_footer_quicklinks_legal_header"
											]
										}
									</h4>
									<ul>
										<li>
											<Link to="/legal/privacy-policy">
												{
													languages[currentLanguage][
														"auth_signup_privacy_button"
													]
												}
											</Link>
										</li>
										<li>
											<Link to="/legal/terms-conditions">
												{languages[currentLanguage]["auth_signup_terms_button"]}
											</Link>
										</li>
										<li>
											<Link to="/legal/cookies-policy">
												{
													languages[currentLanguage][
														"home_footer_quicklinks_legal_cookies"
													]
												}
											</Link>
										</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="col-lg-3 col-md-4 col-sm-5 mb-4">
							<div className="single-footer-caption mb-50">
								<div className="footer-tittle">
									<h4>
										{
											languages[currentLanguage][
												"home_footer_quicklinks_support_header"
											]
										}
									</h4>
									<ul>
										<li>
											<a
												target="_blank"
												href="mailto:support@keeano.zendesk.com"
											>
												{
													languages[currentLanguage][
														"home_footer_quicklinks_support_bug_button"
													]
												}
											</a>
										</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="d-md-none footer-banner px-2 mb-5 py-3">
							<BannerContainer
								src={
									currentLanguage === "EN"
										? bannerEn
										: currentLanguage === "GR"
										? bannerGr
										: ""
								}
							/>
						</div>
					</div>
				</div>
			</div>
		</footer>
	);
}

const mapStateToProps = (state) => {
	return {};
};

const mapDispatchToProps = (dispatch) => {
	return {
		switchLang: (lang) => dispatch(switchLang(lang)),
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(Footer);
